<template>
  <div>
    <!-- Header with slots -->
    <div v-if="$slots.title" class="mb-3">
      <slot name="title" />
    </div>
    <div
      v-if="$slots.controls && canEdit"
      class="is-flex is-align-items-center mb-2"
    >
      <slot name="controls" />
    </div>

    <!-- Dataset List -->
    <ol v-if="datasets.length > 0">
      <li
        v-for="({ selected, object: dataset }, index) of selectableDatasets"
        :key="`dataset${index}-${dataset.id}`"
        class="is-flex is-align-items-center"
        :class="{ 'is-selected': selected }"
      >
        <WorkflowRunDatasetPeek v-bind="dataset" class="flex-grow-1">
          <template #dataset-name>
            <span :dataset-name="dataset.name">
              <label class="is-flex is-align-items-center mr-2" @click.stop>
                <input
                  class="mr-2"
                  type="checkbox"
                  :checked="selected"
                  @change="toggleSelect(index, $event.shiftKey)"
                />
                <span class="ml-2">
                  {{ dataset.name }}
                </span>
              </label>
            </span>
          </template>
          <template #header-controls>
            <span>
              <slot v-if="canEdit" name="unlink-controls">
                <Popover ref="unlinkPopover">
                  <button
                    class="button is-small is-danger is-outlined is-rounded ml-2"
                  >
                    <span class="icon">
                      <i class="fa-solid fa-unlink"></i>
                    </span>
                  </button>
                  <template #popper="{ hide }">
                    <div class="is-flex is-flex-direction-column">
                      <p class="mx-1 mb-3">
                        <span class="icon has-text-info">
                          <i class="fas fa-info-circle"></i>
                        </span>
                        <span>
                          This will only remove the association between this run
                          and
                          <code>{{ dataset.name }}</code>
                          .
                          <code>{{ dataset.name }}</code>
                          will not be deleted.
                        </span>
                      </p>
                      <button
                        class="button is-danger is-outlined is-small is-fullwidth"
                        @click="
                          () => {
                            hide()
                            $emit('unlink-dataset', dataset)
                          }
                        "
                      >
                        <span class="icon">
                          <i class="fa-solid fa-unlink"></i>
                        </span>
                        <span>Unlink</span>
                      </button>
                    </div>
                  </template>
                </Popover>
              </slot>
            </span>
          </template>
        </WorkflowRunDatasetPeek>
      </li>
    </ol>
  </div>
</template>

<script>
import { computed } from 'vue'

import { useSelectableRecords } from '@/composables/useSelectableRecords'

import WorkflowRunDatasetPeek from '@/components/WorkflowRunDatasetPeek.vue'
export default {
  name: 'WorkflowRunDatasetSection',
  components: {
    WorkflowRunDatasetPeek,
  },
  props: {
    datasets: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['unlink-dataset', 'selected'],
  setup(props, { emit }) {
    const { selectables: selectableDatasets, toggleSelect } =
      useSelectableRecords(
        computed(() => props.datasets),
        { emit },
      )

    return {
      selectableDatasets,
      toggleSelect,
    }
  },
}
</script>

<style scoped>
ol {
  list-style-type: none;
  margin-bottom: 1rem;
}

.flex-grow-1 {
  flex-grow: 1;
}

li {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.selection-checkbox {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}

.selection-checkbox input[type='checkbox'] {
  margin: 0;
}
</style>
